/**
 * T FOR ALL — Back in stock via Klaviyo client API.
 * <tfa-back-in-stock> auto-shows a compact email form ONLY while the selected
 * variant is sold out, and subscribes the shopper to Klaviyo Back in Stock for
 * that exact variant. No paid app required.
 * Docs: POST https://a.klaviyo.com/client/back-in-stock-subscriptions/
 */
(function () {
  'use strict';

  customElements.define('tfa-back-in-stock', class extends HTMLElement {
    connectedCallback() {
      this.companyId = this.dataset.companyId;
      this.variantId = this.dataset.variantId;
      this.rowEl = this.querySelector('[data-bis-row]');
      this.subEl = this.querySelector('.tfa-bis__sub');
      this.emailEl = this.querySelector('[data-bis-email]');
      this.submitBtn = this.querySelector('[data-bis-submit]');
      this.msgEl = this.querySelector('[data-bis-msg]');

      this.setAvailable(this.dataset.available === 'true');

      if (this.submitBtn) this.submitBtn.addEventListener('click', () => this.subscribe());
      if (this.emailEl) {
        this.emailEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.subscribe(); } });
      }

      // React to variant switches (Dawn pub/sub).
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event && event.data && event.data.variant;
          if (!variant) { this.setAvailable(true); return; }
          this.variantId = variant.id;
          this.dataset.variantId = variant.id;
          this.reset();
          this.setAvailable(variant.available === true);
        });
      }
    }

    disconnectedCallback() { if (this.unsub) this.unsub(); }

    // Hide the whole component when the variant is in stock; show the form when sold out.
    setAvailable(isAvailable) { this.hidden = !!isAvailable; }

    reset() {
      if (this.rowEl) this.rowEl.hidden = false;
      if (this.subEl) this.subEl.hidden = false;
      if (this.submitBtn) this.submitBtn.disabled = false;
      if (this.msgEl) { this.msgEl.hidden = true; this.msgEl.textContent = ''; this.msgEl.classList.remove('is-error', 'is-ok'); }
    }

    showMsg(text, isError) {
      if (!this.msgEl) return;
      this.msgEl.hidden = false;
      this.msgEl.textContent = text;
      this.msgEl.classList.toggle('is-error', !!isError);
      this.msgEl.classList.toggle('is-ok', !isError);
    }

    validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    subscribe() {
      const email = (this.emailEl && this.emailEl.value || '').trim();
      if (!this.validEmail(email)) { this.showMsg(this.dataset.msgErr, true); if (this.emailEl) this.emailEl.focus(); return; }
      if (!this.companyId || !this.variantId) { this.showMsg(this.dataset.msgErr, true); return; }

      if (this.submitBtn) this.submitBtn.disabled = true;

      const body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + this.variantId } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(this.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then((res) => {
        if (res.ok || res.status === 202) {
          if (this.rowEl) this.rowEl.hidden = true;
          if (this.subEl) this.subEl.hidden = true;
          this.showMsg(this.dataset.msgOk, false);
        } else {
          if (this.submitBtn) this.submitBtn.disabled = false;
          this.showMsg(this.dataset.msgErr, true);
        }
      }).catch(() => {
        if (this.submitBtn) this.submitBtn.disabled = false;
        this.showMsg(this.dataset.msgErr, true);
      });
    }
  });
})();
